import { TarefasRecuperacaoCreditoComponent } from './recuperacao-de-credito/tarefas-recuperacao-de-credito.component';
import { DominiosResolver } from './../../shared/resolvers/dominios.resolver';
import { FeaturesResolver } from './../../shared/resolvers/features.resolver';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthenticationGuard } from "@bndes/bndes-ux4/bn-seguranca";
import { TarefasOperacaoComponent } from './operacao/tarefas-operacao.component';
import { EscolhaModalidadeGuard } from 'src/app/interceptors/escolha-modalidade.guard';
import { TarefasRelatoriosComponent } from './relatorios/tarefas-relatorios.component';
import { TarefasLimitesComponent } from './limite/tarefas-limites.component';
import { TarefasInadimplenciaComponent } from './inadimplencia/tarefas-inadimplencia.component';
import { TarefasHonraComponent } from './honra/tarefas-honra.commponent';
import { TarefasSistemaComponent } from './sistema/tarefas-sistema.component';
import { TarefasContratoSccComponent } from './contrato-scc/tarefas-contrato-scc.component';
import { TarefasCobrancaComponent } from './cobranca/tarefas-cobranca.component';
import { TarefasFgenergiaComponent } from './fgenergia/tarefas-fgenergia.component';
import { TarefasProtocoloComponent } from './protocolo/tarefas-protocolo.component';
import { AgenteFinanceiroResolver } from 'src/app/shared/resolvers/agente-financeiro.resolver';
import { TarefasRemuneracaoComponent } from './remuneracao/tarefas-remuneracao.component';
import { TarefasLeilaoComponent } from './leilao/tarefas-leilao.component';




const routes: Routes = [
  {
    path: 'tarefas',
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    resolve: {
      dominios: DominiosResolver,
      agentes: AgenteFinanceiroResolver
    },
    data: { canReuse: false },
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'relatorios' // ajustar isto depois
      },
      {
        path: 'relatorios',
        component: TarefasRelatoriosComponent,
        resolve: {
          features: FeaturesResolver
        }
      },
      {
        path: 'limites',
        component: TarefasLimitesComponent
      },
      {
        path: 'inadimplencia',
        component: TarefasInadimplenciaComponent
      },
      {
        path: 'honra',
        component: TarefasHonraComponent,
        resolve: {
          dominios: DominiosResolver
        },
      },
      {
        path: 'operacao',
        component: TarefasOperacaoComponent,
        resolve: {
          dominios: DominiosResolver
        },
      },
      {
        path: 'protocolo',
        component: TarefasProtocoloComponent,
        resolve: {
          dominios: DominiosResolver
        },
      },
      {
        path: 'sistema',
        component: TarefasSistemaComponent,
        resolve: {
          dominios: DominiosResolver
        },
      },
      {
        path: 'recuperacao-de-credito',
        component: TarefasRecuperacaoCreditoComponent,
        resolve: {
          dominios: DominiosResolver
        },
      },
      {
        path: 'cobranca',
        component: TarefasCobrancaComponent,
        resolve: {
          dominios: DominiosResolver
        },
      },
      {
        path: 'contrato-scc',
        component: TarefasContratoSccComponent,
        resolve: {
          dominios: DominiosResolver
        },
      },
      {
        path: 'fgenergia',
        component: TarefasFgenergiaComponent,
        resolve: {
          dominios: DominiosResolver
        },
      },
      {
        path: 'remuneracao',
        component: TarefasRemuneracaoComponent
      },
      {
        path: 'leilao',
        component: TarefasLeilaoComponent,
         resolve: {
          dominios: DominiosResolver
        },
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TarefasRoutingModule { }
